import { render, staticRenderFns } from "./TableRowMenu.vue?vue&type=template&id=2a4e3946"
import script from "./TableRowMenu.ts?vue&type=script&lang=ts&external"
export * from "./TableRowMenu.ts?vue&type=script&lang=ts&external"
import style0 from "./TableRowMenu.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports